if (!customElements.get('footer-details')) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      this.boundMatchTablet = () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      };

      this.boundUnmatchTablet = () => {
        this.open = true;
      };

      document.addEventListener('matchTablet', this.boundMatchTablet);
      document.addEventListener('unmatchTablet', this.boundUnmatchTablet);
    }

    disconnectedCallback() {
      if (this.boundMatchTablet) {
        document.removeEventListener('matchTablet', this.boundMatchTablet);
      }
      if (this.boundUnmatchTablet) {
        document.removeEventListener('unmatchTablet', this.boundUnmatchTablet);
      }
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
